<template>
    <div :class="classes">
        <BuildConfig
            v-for="(config, idx) in factory.configs"
            :key="config.id"
            :config="factory.configs[idx]"
            :loading="loading"
            :schema="factory.schema"
            :can-delete="factory.canDelete"
            class="builder-wrapper__config"
            @deleteConfig="deleteConfig"
            @update:config="factory.configs[idx] = $event"
        />
        <button
            v-if="!loading && factory.canAdd"
            class="button button--blank books-builds__add-trigger"
            @click.prevent="addConfig"
            v-text="`+ ${$t('misc.add')}`"
        />
    </div>
</template>
<script>
import BuildConfig from './BuildConfig';

export default {
    name: 'BuilderWrapper',
    components: {
        BuildConfig,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        factory: {
            type: Object,
            required: true,
        },
    },
    computed: {
        classes() {
            return [
                'builder-wrapper',
                {
                    'builder-wrapper--many': this.factory.configs.length > 1,
                },
            ];
        },
    },
    beforeUnmount() {
        this.factory.destroy();
    },
    methods: {
        addConfig() {
            this.factory.addConfig();
        },
        deleteConfig({ id }) {
            this.factory.deleteConfig(id);
        },
    },
};
</script>

<style lang="scss" src="./BuilderWrapper.scss"></style>
